import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch, toImageUrl, formatDate } from '../../utils/api';

export const statusStyles = {
    Delivered: 'bg-[#2f6b1f] text-white',
    Processing: 'bg-amber-400 text-gray-900',
    Cancelled: 'bg-red-600 text-white',
};

const tabs = ['All Orders', 'Delivered', 'Processing', 'Cancelled'];

const Orders = () => {
    const [activeTab, setActiveTab] = useState('All Orders');
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        apiFetch('/orders')
            .then(({ ok, data }) => {
                if (!cancelled && ok && Array.isArray(data)) setOrders(data);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    const list = activeTab === 'All Orders' ? orders : orders.filter((o) => o.status === activeTab);

    return (
        <>
            <h1 className="text-xl font-semibold">My Orders</h1>

            <div role="tablist" className="mt-4 flex flex-wrap gap-2">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        role="tab"
                        aria-selected={activeTab === tab}
                        onClick={() => setActiveTab(tab)}
                        className={`rounded-full border px-5 py-2 text-sm transition ${
                            activeTab === tab
                                ? 'border-gray-200 border-b-2 border-b-[#2f6b1f] bg-white font-medium'
                                : 'border-gray-200 bg-[#eceee7] text-gray-500 hover:bg-white'
                        }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            <section className="mt-5 rounded-xl border border-gray-200 bg-white shadow-sm">
                {loading ? null : list.length === 0 ? (
                    <p className="p-8 text-center text-sm text-gray-500">No {activeTab.toLowerCase()} orders yet.</p>
                ) : (
                    <ul className="divide-y divide-gray-100">
                        {list.map((o) => (
                            <li key={o.id} className="flex flex-wrap items-center gap-4 p-4 sm:flex-nowrap">
                                <div className="flex h-20 w-32 shrink-0 gap-1 overflow-hidden rounded-lg bg-[#f6f6f1] p-1.5">
                                    {o.images.map((src, i) => (
                                        <img key={i} src={toImageUrl(src)} alt="" onError={(e) => (e.currentTarget.style.visibility = 'hidden')} className="h-full w-1/2 rounded object-cover" />
                                    ))}
                                </div>
                                <div className="min-w-0 flex-1">
                                    <p className="text-sm font-medium">Order #{o.orderNo}</p>
                                    <p className="mt-0.5 text-xs text-gray-500">{formatDate(o.createdAt)} • {o.items} {o.items === 1 ? 'item' : 'items'}</p>
                                    <p className="mt-2 text-sm font-semibold">₹{o.total.toLocaleString('en-IN')}</p>
                                </div>
                                <div className="ml-auto flex w-28 shrink-0 flex-col gap-2">
                                    <span className={`rounded-md py-1.5 text-center text-xs font-semibold ${statusStyles[o.status]}`}>{o.status}</span>
                                    <Link to={`/myaccount/orders/${o.id}`} className="rounded-md bg-gray-100 py-1.5 text-center text-xs font-medium text-gray-700 hover:bg-gray-200">View Details</Link>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </section>
        </>
    );
};

export default Orders;
